import _ from '../../../utils/LodashImports';

const getServicesBenefits = ({ siteConfig = {}, regionCode = 'cl' }) => {
  const fallbackServicesList = {
    cl: [
      'Armado de muebles: Cobertura en todo Chile a excepción de zonas rurales.',
      'Instalación: La cobertura dependerá del producto.',
      'Retiro y reciclaje: Cobertura en Región Metropolitana, V región y VI región.',
      'Producto protegido: Protege tu producto durante 120 días contra robo o daño accidental. Cobertura en todo Chile.',
    ],
    pe: ['Ofrecemos distintos servicios de hogar para que puedas disfrutar de tus compras.'],
    co: ['Ofrecemos distintos servicios de hogar para que puedas disfrutar de tus compras.'],
    mx: [],
  };
  const servicesBenefits = _.get(siteConfig, `configurations.servicesBenefits`, fallbackServicesList[regionCode]);

  return servicesBenefits.map((benefit) => {
    if (benefit.includes(':')) {
      const [title, description] = benefit.split(':');
      return { title: title ? `${title}:` : '', description };
    }
    return { title: '', description: benefit };
  });
};

export { getServicesBenefits };
